import { GT, BT, LT } from '../../../../../utils/filterToSearchParams/constants';

const OPTIONS = [
  { value: LT, title: 'Less than' },
  { value: GT, title: 'Greater than' },
  { value: BT, title: 'Between' },
];

export { OPTIONS };
